import { render, staticRenderFns } from "./AmCommission.vue?vue&type=template&id=25b03888&"
import script from "./AmCommission.vue?vue&type=script&lang=js&"
export * from "./AmCommission.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports